/**
 * Fiscal Registration
 * Fiskal Cloud Keycloak API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Realm:  * `df` - DF realm  * `sb` - SB realm  * `df-machine` - DF_MACHINE realm  * `sb-machine` - SB_MACHINE realm  * `df-m2m` - DF_M2M realm  * `df-archive-m2m` - DF_ARCHIVE_M2M realm 
 */
export enum RealmDTO {
    DF = 'df',
    SB = 'sb',
    DF_MACHINE = 'df-machine',
    SB_MACHINE = 'sb-machine',
    DF_M2M = 'df-m2m',
    DF_ARCHIVE_M2M = 'df-archive-m2m'
}

export class ClsRealmDTO {
    DF = 'df';
    SB = 'sb';
    DF_MACHINE = 'df-machine';
    SB_MACHINE = 'sb-machine';
    DF_M2M = 'df-m2m';
    DF_ARCHIVE_M2M = 'df-archive-m2m';
}

